/*jslint node: true */
'use strict';

import Vuex from 'vuex';
import Vue from 'vue';
import Cookies from 'vue-js-cookie';
import API from '../services/api';
import dataService from '../services/data-service';

const api = new API();

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loggedIn: Cookies.get('loggedIn') ? true : false,
    logoutStatus: false,
    scroll: false,
    user: {},
    notifications: {
      sendSms: false,
      sendMail: false,
      sendPost: false,
    },
    messages: false,
    events: false,
    cars: {
      current: '',
      active: [],
      loading: true
    },
    brands: [],
    stores: [],
    vouchers: false,
    brandPhonenumbers: false,
    carSearches: false,
    articles: false,
    testdrives: false,
    recommendations: [],
    contestStatus: false,
    fiksudiilifaq: []
  },
  mutations: {
    setActiveCar(state, res) {
      state.cars.current = res;
    },
    setLoggedIn(state, res) {
      state.loggedIn = res;
    },
    setLogoutStatus(state, res) {
      state.logoutStatus = res;
    },
    setUserData(state, res) {
      state.user = res;
    },
    setUserNotifications(state, res) {
      state.notifications = res;
    },
    setUserMessages(state, res) {
      state.messages = res;
    },
    setUserEvents(state, res) {
      state.events = res;
    },
    setUserCars(state, res) {
      state.cars = res;
    },
    setBrands(state, res) {
      state.brands = res;
    },
    setUserVouchers(state, res) {
      state.vouchers = res;
    },
    setStores(state, res) {
      state.stores = res;
    },
    setBrandPhonenumbers(state, res) {
      state.brandPhonenumbers = res;
    },
    setCarSearches(state, res) {
      state.carSearches = res;
    },
    setArticles(state, res) {
      state.articles = res;
    },
    setScroll(state, res) {
      state.scoll = res;
    },
    setTestdrives(state, res) {
      state.testdrives = res;
    },
    setFiksudiiliRecommendations(state, res) {
      state.fiksudiilirecommendations = res;
    },
    setRecommendations(state, res) {
      state.recommendations = res;
    },
    setContestStatus(state, res) {
      state.contestStatus = res;
    },
    setFiksudiiliFAQ(state, res) {
      state.fiksudiilifaq = res;
    }
  },
  actions: {
    init({ dispatch, commit }) {
      dispatch('getBrands');
      dispatch('getStores');
      dispatch('getUserMessages');
      dispatch('getUserEvents');
      dispatch('getNotifications');
      dispatch('getUserVouchers');
      dispatch('getCarSearches');
      dispatch('getUserTestdrives');
      dispatch('getUserRecommendations');
      dispatch('getOmaLaakkonenContestStatus');
    },
    getBrands({ dispatch, commit }) {
      return api
        .getBrands()
        .then(res => {
          commit('setBrands', res.brands);
          dispatch('getUserInfo');
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getUserInfo({ dispatch, commit }) {
      return api
        .getUserInfo()
        .then(res => {
          let user = res;

          api
            .getBrands()
            .then(res => {
              let brands = res.brands.map(brand => {
                for (let i = 0; i < user.brands.length; i++) {
                  if (brand.id === user.brands[i].id) brand.checked = true;
                }

                return brand;
              });

              delete user.brands;

              commit('setUserData', user);
              commit('setBrands', brands);

              dispatch('getUserCars');
              dispatch('getArticles');
            })
            .catch(error => {
              //console.log(error.statusText);
            });
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getStores({ commit }) {
      return api
        .getStores()
        .then(res => {
          commit('setStores', res.stores);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getNotifications({ commit }) {
      return api
        .getNotificationsStatus()
        .then(res => {
          commit('setUserNotifications', res);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getUserMessages({ commit }) {
      return api
        .getUserMessages()
        .then(res => {
          commit('setUserMessages', res.items);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getUserEvents({ commit }) {
      return api
        .getUserEvents()
        .then(res => {
          commit('setUserEvents', res.events);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getUserCars({ commit }) {
      return api
        .getAllCarsInfo()
        .then(res => {
          let numbers = [];
          let active = res.cars.map(car => {

            numbers.push(car.brand_phonenumbers);
            car.estimate = false;
            car.estimate_ask_allowed = false;

            var brand = car.brand_name;
            var model = car.model_name;
            var limit = 3;
            api
              .getFiksudiiliRecommendedCars({
                brand: brand,
                model: model,
                limit: limit
              })
            .then(res => {
              car.recommendations = res;
              let defaultLicense = active[0].license;
              commit('setUserCars', {
                active: active,
                current: defaultLicense,
                loading: false,
              });
            })
            .catch(error => {
              //console.log(error.statusText);
            });
            return car;
          });

          if (!active.length) {
            commit('setUserCars', {
              active: [],
              current: '',
              loading: false,
            });
          }

          commit('setBrandPhonenumbers', numbers);

          api
            .getCarsTradeEstimate()
            .then(res => {
              active = active.map(car => {
                for (let i = 0; i < res.cars.length; i++) {
                  const estimate = res.cars[i];

                  if (car.license === estimate.license) car = Object.assign(car, estimate);
                }

                return car;
              });
            })
          .catch(error => {
            console.log({
              error: error,
            });
          });

          api
            .getFiksudiiliFaq()
            .then(res => {
              commit('setFiksudiiliFAQ', res);
            })
          .catch(error => {
            console.log({
              error: error,
            });
          });

        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getUserVouchers({ commit }) {
      return api
        .getUserVouchers()
        .then(res => {
          commit('setUserVouchers', res.vouchers);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getCarSearches({ commit }) {
      return api
        .getCarSearches()
        .then(res => {
          commit('setCarSearches', res);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getArticles({ commit }) {
      function getBrandArticles(brands, articles) {
        let brand = brands[0];

        api
          .getArticles({
            brand: brand,
          })
          .then(res => {
            articles.push({
              brand: brand,
              items: res,
            });

            brands.splice(0, 1);

            if (brands.length > 0) getBrandArticles(brands, articles);
            else commit('setArticles', articles);
          })
          .catch(error => {
            //console.log(error.statusText);
          });
      }

      return api
        .getArticles()
        .then(res => {
          let brands = this.state.brands.reduce((result, brand) => {
            if (brand.checked) result.push(brand.id);
            return result;
          }, []);

          let articles = [
            {
              brand: false,
              items: res,
            },
          ];

          getBrandArticles(brands, articles);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getUserTestdrives({ commit }) {
      return api
        .getUserTestdrives()
        .then(res => {
          commit('setTestdrives', res.drives);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getUserRecommendations({ commit }) {
      return api
        .getUserRecommendations()
        .then(res => {
          commit('setRecommendations', res.recommendations);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getOmaLaakkonenContestStatus({ commit }) {
      return api
        .getOmaLaakkonenContestStatus()
        .then(res => {
          if (res.status === 1) commit('setContestStatus', res);
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
  },
});

dataService.setVuexStore(store);

export default store;
